import React from "react";
import {
  Button,
  FormFieldSet,
  LoopFieldsSet,
  PageTitle,
} from "../../../../../components";
import { v4 as uuidv4 } from "uuid";
import useIncentiveSetting from "./useIncentiveSetting";

const NonItSetting = ({ onClose }) => {
  const initialFormData = {
    quarterlyTarget: "",
    yearlyTarget: "",
    generalPct: "",
    q1Pct: "",
    fiscalYearPct: "",
    incentiveType: "",
    nonItSettingDetails: [
      {
        id: uuidv4(),
        invoicePaidRequired: "",
        warranty: "",
        probationPeriod: "",
      },
    ],
  };

  const validationConfig = {
    quarterlyTarget: { type: "text", number: true, required: true },
    yearlyTarget: { type: "text", number: true, required: true },
    generalPct: { type: "text", number: true, required: true },
    q1Pct: { type: "text", number: true, required: true },
    fiscalYearPct: { type: "text", number: true, required: true },
    incentiveType: { type: "select", required: true },
    nonItSettingDetails: [
      {
        invoicePaidRequired: { type: "select", required: true },
        warranty: { type: "select", required: true },
        probationPeriod: { type: "select", required: true },
      },
    ],
  };

  const {
      formData,
      errors,
      handleChange,
      loading,
      addItem,
      removeItem,
      saveSettings,
    } = useIncentiveSetting({
        settingsKey: "INCENTIVE_NON_IT",
        listFieldName: "nonItSettingDetails",
        initialFormData,
        validationConfig,
        onClose
    });

  return (
    <div className="flex flex-col mt-5">
        <PageTitle
        title="Targets"
        tag="p"
        className="text-gray-400 text-sm mb-2"
        />
        <div className="grid xs:grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
            <FormFieldSet
                title="Incentive Type"
                placeholder="Select Type"
                type="select"
                options={[
                    { label: "Percentage (%)", value: "percentage" },
                    { label: "Flat Amount ($)", value: "flat" },
                ]}
                value={formData.incentiveType || ""}
                onChange={(value) => handleChange("incentiveType", value)}
                error={errors.incentiveType}
                required={true}
            />
            <FormFieldSet
                title="General Rate"
                placeholder="Enter value"
                value={formData.generalPct || ""}
                onChange={(value) => handleChange("generalPct", value)}
                error={errors.generalPct}
                required={true}
            />
            <FormFieldSet
                title="Quarterly Rate"
                placeholder="Enter value"
                value={formData.q1Pct || ""}
                onChange={(value) => handleChange("q1Pct", value)}
                error={errors.q1Pct}
                required={true}
            />
            <FormFieldSet
                title="Yearly Rate"
                placeholder="Enter value"
                value={formData.fiscalYearPct || ""}
                onChange={(value) => handleChange("fiscalYearPct", value)}
                error={errors.fiscalYearPct}
                required={true}
            />
        </div>
        <div className="grid xs:grid-cols-2 xl:grid-cols-3 gap-4 mb-6">
            <FormFieldSet
                title="Quarterly Target (Placement Count)"
                placeholder="Enter count"
                value={formData.quarterlyTarget || ""}
                onChange={(value) => handleChange("quarterlyTarget", value)}
                error={errors.quarterlyTarget}
                required={true}
            />
            <FormFieldSet
                title="Yearly Target (Placement Count)"
                placeholder="Enter count"
                value={formData.yearlyTarget || ""}
                onChange={(value) => handleChange("yearlyTarget", value)}
                error={errors.yearlyTarget}
                required={true}
            />
        </div>

      <div className="flex flex-col gap-4 -mt-4">
        <LoopFieldsSet
          title="Non-IT Incentive"
          titleConfig={{ tag: "p", className: "text-gray-400 text-sm" }}
          data={formData.nonItSettingDetails}
          onAdd={addItem}
          onRemove={removeItem}
          minItems={1}
          maxItems={5}
          addButtonTitle="Add More"
          gridCols="grid-cols-[1fr_30px] gap-1!"
          renderFields={(item, index) => (
            <>
              <div className="flex flex-col gap-4 p-0">
                <div className="grid xs:grid-cols-2 xl:grid-cols-3 gap-4">
                  <FormFieldSet
                    title="Invoice Paid Required"
                    placeholder="Select"
                    type="select"
                    options={[
                      { label: "Yes", value: "yes" },
                      { label: "No", value: "no" },
                    ]}
                    value={item.invoicePaidRequired || ""}
                    onChange={(value) =>
                      handleChange(
                        `nonItSettingDetails[${index}].invoicePaidRequired`,
                        value
                      )
                    }
                    error={
                      errors.nonItSettingDetails?.[index]?.invoicePaidRequired
                    }
                    required={true}
                  />
                  <FormFieldSet
                    title="Warranty"
                    placeholder="Select"
                    type="select"
                    options={[
                      { label: "Restricted", value: "restricted" },
                      { label: "Not Restricted", value: "notRestricted" },
                    ]}
                    value={item.warranty || ""}
                    onChange={(value) =>
                      handleChange(
                        `nonItSettingDetails[${index}].warranty`,
                        value
                      )
                    }
                    error={errors.nonItSettingDetails?.[index]?.warranty}
                    required={true}
                  />
                  <FormFieldSet
                    title="Probation"
                    placeholder="Select"
                    type="select"
                    options={[
                      { label: "No restriction", value: "0" },
                      { label: "1 month", value: "1m" },
                      { label: "2 months", value: "2m" },
                      { label: "3 months", value: "3m" },
                      { label: "6 months", value: "6m" },
                      { label: "12 months", value: "12m" },
                    ]}
                    value={item.probationPeriod || ""}
                    onChange={(value) =>
                      handleChange(
                        `nonItSettingDetails[${index}].probationPeriod`,
                        value
                      )
                    }
                    error={errors.nonItSettingDetails?.[index]?.probationPeriod}
                    required={true}
                  />
                </div>
              </div>
            </>
          )}
        />
        <div className="flex items-center justify-end gap-3">
          <Button title="Cancel" variant="outlined" onClick={onClose} />
          <Button title={loading ? "Saving..." : "Save"} onClick={saveSettings} disabled={loading} />
        </div>
      </div>
    </div>
  );
};

export default NonItSetting;
